import { c as _c } from "react/compiler-runtime";
import { runtimeConfig } from "@src/runtime-config";
import { HBCookieManagerProvider } from "@faro-lotv/foreign-observers";

/**
 * Loads both the Cookie Manager and Google Tag Manager
 */
export function CookieManagerLoader(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      preferencesButton: false,
      preferencesButtonPosition: "bottom right",
      requireBabelPolyfill: true,
      requireJquery: true,
      requireBootstrap: true,
      triggerGoogleTagManager: true,
      delay: 300
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <HBCookieManagerProvider cookieManagerUrl={runtimeConfig.urls.cookieManagerUrl} options={t1}>{children}</HBCookieManagerProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}